import { memo, useEffect, useState } from "react";

const Footer = () => {
    
    return (
        <>
        
        </>
    );
}

export default memo(Footer);